var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p-row',{class:_vm.variant},[_c('p-col',{attrs:{"md":"3"}}),_c('p-col',{attrs:{"md":"6"}},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.keyTranslator)))])]),_c('p-col',{attrs:{"md":"3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }